import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../lib/api";

export default function StickyWhatsApp() {
  return (
    <a
      href={WHATSAPP_URL()}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[60] w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center wa-pulse shadow-2xl hover:scale-110 transition-transform"
      aria-label="Chat on WhatsApp"
      data-testid="sticky-whatsapp-btn"
    >
      <MessageCircle size={26} fill="currentColor" />
    </a>
  );
}
